import { WorkingCenterShippingServiceModelType } from '@teinor/erp/types/company/workingCenter/workingCenterShippingService'
import { useParams } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { LittleModalCreateEdit } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../../../utils/globals/dictionary'
import { parseShippingServicesToDict } from '../../../../../../../../../../utils/globals/shippingService'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalCreateShippingServiceWorkingCenterProps extends ModalEditComponentProps {}

const ModalCreateShippingServiceWorkingCenter: React.FC<ModalCreateShippingServiceWorkingCenterProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { parsedShippingServices, id, selectedShippingServices } = useModalCreateShippingServiceWorkingCenterLogic()
    const fields: FormRender<WorkingCenterShippingServiceModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'ShippingServiceId',
                    label: t('shippingService', 'Servicio Transportista'),
                    component: 'CustomSelectSearchBarWithNotInFilteredItems',
                    items: parsedShippingServices,
                    excludeItems: selectedShippingServices,
                    required: true
                },
                {
                    name: 'is_main',
                    label: t('byDefault', 'Por defecto'),
                    component: 'Checkbox'
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: id
                }
            ],
        },
    ]
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/workingCenter/workingCenterShippingService/createWorkingCenterShippingService'} translations={{
        title: t('addShippingServiceWorkingCenter', 'Añadir servicio de transporte a este Centro de trabajo'),
        button: t('add', 'Añadir')
    }} haveButtonPermissions={true} {...rest} />)
}

const useModalCreateShippingServiceWorkingCenterLogic = () => {
    const [parsedShippingServices, setParsedShippingServices] = useState<TwinDictionary>({})
    const [selectedShippingServices, setSelectedShippingServices] = useState<string[]>([])
    const { id } = useParams()


    const getSelectedShippingServices = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/workingCenter/workingCenterShippingService/getAllWorkingCenterShippingServices', { where: { 'WorkingCenterId': id } })
        const selected: string[] = []
        for (const selectedShippingService of result) {
            selected.push(String(selectedShippingService?.ShippingServiceId))
        }
        return selected
    }, [id])
    const getShippingServices = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/config/shipping/shippingCompany/service/getAllShippingServicesComplete', {})
        return result
    }, [])

    const getData = useCallback(async () => {
        const selected = await getSelectedShippingServices()
        const allShippingServices = await getShippingServices()
        if (allShippingServices) {
            setParsedShippingServices(parseShippingServicesToDict(allShippingServices))
        }
        setSelectedShippingServices(selected)
    }, [getSelectedShippingServices, getShippingServices])

    useEffect(() => {
        getData()
    }, [getData])

    return { parsedShippingServices, id, selectedShippingServices }
}


export default ModalCreateShippingServiceWorkingCenter;